import {
    setSearchStats,
    trackLegacySearchEvent,
    trackSearchFlyoutClick,
    trackSubmitSearchEvent,
} from '@libs/analytics';

import type { SearchSuggestionItem } from '../search.types';
import { getSearchSuggestionAssistName } from '../utils';

type TrackProps = {
    isPrimarySelection: boolean;
    item: SearchSuggestionItem;
    query: string;
    url: string;
};

export function trackSuggestionSelection({ isPrimarySelection, item, query, url }: TrackProps) {
    const header = getSearchSuggestionAssistName(item);

    setSearchStats({ searchTerm: item.label, searchType: 'assisted' });
    trackSearchFlyoutClick({ term: query, header, url });

    if (isPrimarySelection) {
        trackSubmitSearchEvent(item.label, header, query);
        trackLegacySearchEvent(item.label, header);
    }
}
